const LogsViewer = function(logsContainer) {
    this.$container = $(logsContainer);
    this.$toolbar = $('.logs-toolbar');
    this.$table = this.$container.find('.logs-table');
    $('#standard-modal').find('.modal-dialog').addClass('modal-xl');
    $('#standard-modal').find('.modal-content').addClass('h-100');
    this.attachEvents();
    this.loadLogs();
};

LogsViewer.prototype = {
    constructor: LogsViewer,
    $container: undefined,
    $toolbar: undefined,
    $table: undefined,
    tplFullView: undefined,
    attachEvents: function() {
        var self = this;
        this.$toolbar.find('.file-select,.type-select').on('change', function() {
            self.loadLogs();
        });
        this.$toolbar.find('.search-input').on('keyup', function(evt) {
            if (evt.keyCode === 13) { // ENTER
                self.loadLogs();
            }
        });
        this.$toolbar.find('.search-btn').on('click', function() {
            self.loadLogs();
        });
        this.$table.on('click', '.context-btn', function(evt) {
            var $td = $(evt.target).closest('td'),
                $tr = $td.closest('tr');
            self.openLogContext({
                datetime: $tr.find('td:nth-child(1)').html(),
                env: $tr.find('td:nth-child(2)').html(),
                type: $tr.find('td:nth-child(3)').html(),
                message: $tr.find('td:nth-child(4)').html(),
                context: atob($td.find('.context').html()),
                contextData: JSON.parse($td.find('.context-json').html())
            });
            // self.openLogContext(
            //     $td.closest('tr').find('td:first-child').html(),
            //     atob($td.find('.context').html()),
            //     JSON.parse($td.find('.context-json').html())
            // );
        });
        this.$toolbar.find('.refresh-btn').on('click', function() {
            self.loadLogs();
        });
    },
    loadLogs: function() {
        var self = this;
        var data = {
            file: this.$toolbar.find('.file-select').val(),
            type: this.$toolbar.find('.type-select').val(),
            search: this.$toolbar.find('.search-input').val()
        };
        $.post('/admin/logs/api', data).then(function(response) {
            var $tbody = self.$table.find('tbody');
            $tbody.find('tr').remove();
            response.forEach(function(value) {
                var $row = $('<tr>');
                $row.append($(`<td class="collapsed-col">${value.datetime}</td>`));
                $row.append($(`<td class="collapsed-col">${value.env}</td>`));
                $row.append($(`<td class="collapsed-col">${value.type}</td>`));
                $row.append($(`<td>${value.message}</td>`));
                $row.append($(
                    '<td class="collapsed-col text-end">' + (value.context ? '<button class="btn btn-outline-primary btn-sm context-btn"><i class="bi bi-plus"></i></button><div class="context-json d-none">' + JSON.stringify(value.context) + '</div><div class="context d-none">' + value.contextDump + '</div>' : '') + '</td>'
                ));
                $tbody.append($row);
            });
        });
    },
    openLogContext: function(data) {
    // openLogContext: function(title, context, contextData) {
        var self = this,
            $modal = $('#standard-modal'),
            instance = bootstrap.Modal.getOrCreateInstance($modal[0]),
            viewData = Object.assign({}, data);

        if (viewData.contextData.exception) {
            viewData.exception = viewData.contextData.exception
                .replace(/\[previous exception\]/g, "\n[previous exception]")
                .replace(/\[object\] /g, "[object]\n    ")
                .replace(/\[stacktrace\]/g, "\n[stacktrace]")
                .replaceAll(/#([\d]+) /g, "\n    #$1 ");
        }

        $modal.find('.modal-body').html('');
        $modal.find('.modal-body').append(self.renderFullView(viewData));
        $modal.find('.modal-header h5').html(data.datetime);

        instance.show();
    },
    renderFullView: function(data) {
        var self = this;
        if (!self.tplFullView) {
            self.tplFullView = _.template(document.querySelector('#tpl_full_view').innerHTML);
        }
        console.log(self.tplFullView(data));
        return self.tplFullView(data);
    }
};

module.exports = LogsViewer;